import { alpha } from '@mui/material/styles';
import CalculateIcon from '@mui/icons-material/Calculate';
import DomainIcon from '@mui/icons-material/Domain';
import EventNoteIcon from '@mui/icons-material/EventNote';
import PublicIcon from '@mui/icons-material/Public';
import RequestQuoteIcon from '@mui/icons-material/RequestQuote';
import BalanceIcon from '@mui/icons-material/Balance';
import PermMediaIcon from '@mui/icons-material/PermMedia';
import PriceChangeIcon from '@mui/icons-material/PriceChange';
import ShoppingCartIcon from '@mui/icons-material/ShoppingCart';
import AssessmentIcon from '@mui/icons-material/Assessment';
import PaymentsIcon from '@mui/icons-material/Payments';
import StorefrontIcon from '@mui/icons-material/Storefront';
import SettingsIcon from '@mui/icons-material/Settings';
import LocalShippingIcon from '@mui/icons-material/LocalShipping';
import GroupsIcon from '@mui/icons-material/Groups';
import PersonIcon from '@mui/icons-material/Person';
import TaskAltIcon from '@mui/icons-material/TaskAlt';
import LocalOfferIcon from '@mui/icons-material/LocalOffer';
import HistoryIcon from '@mui/icons-material/History';
import { PERMISSION_AUDIENCE, PERMISSION_AUDIENCE_RU } from '@sr/dto';

export type AudienceTheme = { color: string; icon: JSX.Element };
export type AudienceKey = keyof typeof PERMISSION_AUDIENCE_RU;

export const THEMES: Record<AudienceKey, AudienceTheme> = {
  [PERMISSION_AUDIENCE.AUDIT]: { color: '#546e7a', icon: <HistoryIcon fontSize="small" /> }, // Аудит
  [PERMISSION_AUDIENCE.ACCOUNTING]: { color: '#1976d2', icon: <CalculateIcon fontSize="small" /> }, // Бухгалтерия
  [PERMISSION_AUDIENCE.COMPANY]: { color: '#5e35b1', icon: <DomainIcon fontSize="small" /> }, // Компании
  [PERMISSION_AUDIENCE.EVENT]: { color: '#7b1fa2', icon: <EventNoteIcon fontSize="small" /> }, // Дела
  [PERMISSION_AUDIENCE.TASKS]: { color: '#f9a825', icon: <TaskAltIcon fontSize="small" /> }, // Задачи
  [PERMISSION_AUDIENCE.GEOGRAPHY]: { color: '#2e7d32', icon: <PublicIcon fontSize="small" /> }, // География
  [PERMISSION_AUDIENCE.INVOICE]: { color: '#ef6c00', icon: <RequestQuoteIcon fontSize="small" /> }, // Счета
  [PERMISSION_AUDIENCE.LEGAL_ENTITY]: { color: '#6d4c41', icon: <BalanceIcon fontSize="small" /> }, // Юр.лица
  [PERMISSION_AUDIENCE.MEDIA]: { color: '#d81b60', icon: <PermMediaIcon fontSize="small" /> }, // Медиа и СМИ
  [PERMISSION_AUDIENCE.PRICE]: { color: '#00897b', icon: <PriceChangeIcon fontSize="small" /> }, // Прайсы
  [PERMISSION_AUDIENCE.PURCHASES]: { color: '#0288d1', icon: <ShoppingCartIcon fontSize="small" /> }, // Заявки/покупки
  [PERMISSION_AUDIENCE.REPORT]: { color: '#455a64', icon: <AssessmentIcon fontSize="small" /> }, // Отчёты
  [PERMISSION_AUDIENCE.SALARY]: { color: '#43a047', icon: <PaymentsIcon fontSize="small" /> }, // Зарплата
  [PERMISSION_AUDIENCE.SALES_DEPARTMENTS]: { color: '#8e24aa', icon: <StorefrontIcon fontSize="small" /> }, // Отделы продаж
  [PERMISSION_AUDIENCE.SETTING]: { color: '#616161', icon: <SettingsIcon fontSize="small" /> }, // Настройки
  [PERMISSION_AUDIENCE.TAGS]: { color: '#301fb5ff', icon: <LocalOfferIcon fontSize="small" /> }, // Теги
  [PERMISSION_AUDIENCE.SUPPLIERS]: { color: '#8d6e63', icon: <LocalShippingIcon fontSize="small" /> }, // Поставщики
  [PERMISSION_AUDIENCE.USERS]: { color: '#1e88e5', icon: <GroupsIcon fontSize="small" /> }, // Пользователи
  [PERMISSION_AUDIENCE.USER]: { color: '#3949ab', icon: <PersonIcon fontSize="small" /> }, // Пользователь (общее)
};

export const chipSx = (color: string) => ({
  borderColor: color,
  bgcolor: alpha(color, 0.08),
  color,
  '& .MuiChip-icon': { color },
});
